import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { formatDay, useUpgrade } from '../hooks/useUpgrade';
import { Button } from './ui';
import './PaidPlanSelector.css';

interface PaidPlanSelectorProps {
  currentPlan: number;
}

/** 프로필의 "사용자 플랜" 카드: AI Power User 상태와 구독 관리로 가는 버튼 */
const PaidPlanSelector: React.FC<PaidPlanSelectorProps> = ({ currentPlan }) => {
  const { user } = useAuth();
  const { openPlans } = useUpgrade();
  const power = user?.ai_power;

  const label = power?.aiPower ? 'AI Power User' : currentPlan === 1 ? 'Light User' : '일반 사용자';
  const description = (() => {
    if (!power?.aiPower) return '기본 시험 기능. AI Power User는 30일 무료로 써 볼 수 있습니다.';
    if (power.source === 'admin') return '관리자 계정: 모든 AI 기능 사용';
    if (power.source === 'trial') return `무료 체험 중 · ${formatDay(power.until)}까지`;
    if (power.source === 'manual') return `이용 기간 부여됨 · ${formatDay(power.until)}까지`;
    return '구독 중';
  })();

  return (
    <div className="paid-plan-selector">
      <h3>사용자 플랜</h3>
      <div className="current-plan">
        <div>
          <div className="plan-badge">{label}</div>
          <div className="plan-description">{description}</div>
        </div>
        {power?.source !== 'admin' && (
          <Button variant="secondary" size="sm" onClick={openPlans}>{power?.aiPower ? '구독 관리' : '무료 체험·구독'}</Button>
        )}
      </div>
    </div>
  );
};

export default PaidPlanSelector;
